export default __webpack_public_path__ + "static/media/SI.64ea1291.png";